import React, { createContext, useState, useEffect, useMemo } from "react";
import axios from "../config/axiosConfig";
import { useNavigate } from "react-router-dom";

export const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  const value = useMemo(
    () => ({ user, setUser, isLoggedIn, loading }),
    [user, isLoggedIn, loading]
  );
  const getUserPermissions = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/users/login/check-auth`);
      if (response.data.error || response.data.data === null) {
        setIsLoggedIn(false);
        setUser(null);
      } else {
        setUser(response.data.data);
        setIsLoggedIn(true);
      }
    } catch (err) {
      setIsLoggedIn(false);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getUserPermissions();
  }, []);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
